










import {Component, Vue, Prop} from 'vue-property-decorator';
@Component({
    components: {


    },
    name: 'BaseModal',
})
export default class BaseModal extends Vue{
    @Prop({ default: false })show!:boolean
    @Prop({ default: "600px" }) containerWidth!: string
}
